module.exports = __webpack_public_path__ + "static/media/logo-dwitter-500x500px.b2855e3a.png";